import React from "react";
import { makeStyles, ButtonBase } from "@material-ui/core";
import moment from "moment";
import { useFormikContext } from "formik";

import SelectedBulletIcon from "../../../assets/selectedBullet.svg";
const DATE_FORMAT = "DD/MM/YYYY";
const formatSlotString = (timeslot) => {
  const localizedBeginning = new Date(timeslot.time_span_beginning).toLocaleString("fr-FR", {
    timeZone: "Europe/Paris",
    hour: "2-digit",
    minute: "2-digit",
  });
  const localizedEnding = new Date(timeslot.time_span_end).toLocaleString("fr-FR", {
    timeZone: "Europe/Paris",
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${localizedBeginning} - ${localizedEnding}`;
};

export default function SlotChoices({ timeslots }) {
  const formik = useFormikContext();
  const classes = useStyle();
  function selectSlot(day, slot) {
    formik.setValues({
      ...formik.values,
      date: day.format(DATE_FORMAT),
      slot: formatSlotString(slot),
      shipping_provider_id: slot.shipping_provider_id,
      slotObject: slot,
    });
  }

  return (
    <div className={classes.container}>
      {timeslots?.map((slot, index) => {
        let day = slot && moment(slot.time_span_beginning);
        const selected =
          formik.values.slotObject?.time_span_beginning &&
          slot?.time_span_beginning &&
          moment(formik.values.slotObject.time_span_beginning).isSame(moment(slot.time_span_beginning));
        return (
          slot && (
            <ButtonBase
              disableRipple
              key={index}
              name="date"
              variant="contained"
              onClick={() => selectSlot(day, slot)}
              className={`${classes.button} ${selected ? classes.selected : null}`}
            >
              {selected && <SelectedBulletIcon className={classes.bullet} />}
              {formatSlotString(slot)}
            </ButtonBase>
          )
        );
      })}
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  emptySlot: {
    width: 15,
    height: 4,
    borderRadius: 4,
    backgroundColor: "white",
  },
  emptySlotContainer: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: 20,
  },
  bullet: {
    position: "absolute",
    left: theme.spacing(2),
  },
  emptyContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    boxSizing: "border-box",
    justifyContent: "space-between",
  },
  container: {
    boxSizing: "border-box",
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  button: {
    position: "relative",
    border: "1px solid #DBDFE8",
    borderRadius: 10,
    fontFamily: "GT Welsheim Pro",
    backgroundColor: "white",
    padding: 12,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginTop: 5,
    fontWeight: 500,
    width: "100%",
    "&:hover": {
      backgroundColor: "#F6F6F6",
    },
  },
  selected: {
    border: `2px solid ${theme.palette.secondary.main}`,
    color: theme.palette.secondary.main,
    fontWeight: 700,
    margin: -1,
    marginTop: 4,
  },
}));
